import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-list-offer',
  templateUrl: './list-offer.component.html',
  styleUrls: ['./list-offer.component.scss']
})
export class ListOfferComponent implements OnInit {

  offers
  deletePopupUiData: any;
  offerDetails: any = {}
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router:Router,
    public toast: ToastClientService,
    private modalService: NgbModal,
    ) { }

  ngOnInit() {
    this.getAlloffers();
  }

  getAlloffers() {
    this.apiService.get(this.apiConfig.getAllOffers)
      .subscribe((res: any) => {
        this.offers = res.data.offer_data
      }, err => {
        console.log(err);
      })
  }

  addOffer() {
    this.router.navigateByUrl('/hubAdmin/add-offer');
  }

  // updateOffer(id){
  //   this.router.navigate(['/hubAdmin/update-offer'],{ queryParams: { offerId: id } })
  // }

  //display products in a modal if type is products
  showProductsModal(targetModal, offerData) {

    this.getOfferData(offerData);
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
  }

  getOfferData(offerData){
    this.apiService.get(this.apiConfig.getOfferDetails + offerData.id)
    .subscribe((res:any)=>{
      this.offerDetails = res.data;
      console.log('od', this.offerDetails)
    },err=>{
      this.toast.Error('Error getting offer details')
    })
  };

  deleteModal(targetModal, offer){
    this.deletePopupUiData = offer

    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static',
    });

  }
  
  deleteOffer(offer){

    let payload = {
      program_id : 1, 
      offer_id: offer.id
    }

    this.apiService.postWithFormData(this.apiConfig.deleteOffer, payload)
    .subscribe((res:any)=>{
      if(res.status == 200){
        this.toast.Success("Offer Deleted");
        this.modalService.dismissAll();
        this.getAlloffers();
      }else{
        this.toast.Error('Error deleting offer');
      }
    })

  }


}
